import { useTranslation } from "react-i18next";
import { Plane, MapPin, Mountain, Crown, Bus, Car } from "lucide-react";

const serviceKeys = [
  { key: "airport", icon: Plane, value: "airport" },
  { key: "intercity", icon: MapPin, value: "intercity" },
  { key: "excursions", icon: Mountain, value: "excursion" },
  { key: "vip", icon: Crown, value: "vip" },
  { key: "rental", icon: Car, value: "rental" },
  { key: "group", icon: Bus, value: "group" },
];

const Services = () => {
  const { t } = useTranslation();

  const handleServiceClick = (serviceValue: string) => {
    window.dispatchEvent(new CustomEvent("select-service", { detail: serviceValue }));
    document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" className="py-24 bg-card">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <p className="font-body text-sm tracking-[0.3em] uppercase text-primary mb-4">{t("services.label")}</p>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-4">
            {t("services.title")} <span className="text-gradient-gold">{t("services.titleHighlight")}</span>
          </h2>
          <p className="font-body text-muted-foreground max-w-xl mx-auto">{t("services.description")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {serviceKeys.map((s) => (
            <button
              key={s.key}
              type="button"
              onClick={() => handleServiceClick(s.value)}
              className="group relative bg-background border border-primary/20 rounded-xl p-8 hover:border-primary hover:shadow-xl hover:shadow-primary/10 hover:-translate-y-1 transition-all duration-300 text-left cursor-pointer overflow-hidden"
            >
              <div className="absolute top-0 left-0 h-1 w-full bg-gradient-to-r from-primary to-primary/40 opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-primary to-primary/70 flex items-center justify-center mb-6 shadow-md shadow-primary/20 group-hover:scale-110 transition-transform duration-300">
                <s.icon className="w-7 h-7 text-primary-foreground" />
              </div>
              <h3 className="font-heading text-xl font-semibold text-foreground mb-3 group-hover:text-primary transition-colors">{t(`services.${s.key}.title`)}</h3>
              <p className="font-body text-sm text-muted-foreground leading-relaxed mb-4">{t(`services.${s.key}.desc`)}</p>
              <span className="inline-flex items-center gap-1 font-body text-sm font-semibold text-primary group-hover:gap-2 transition-all">
                {t("common.bookArrow")}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
